getQuerySeparator